var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('InvoiceInfo',{attrs:{"data":_vm.invoice}},[_c('template',{slot:"action"},[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" Back ")])],1)],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }